// src/App.js

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './route/PrivateRoute';
import PublicRoute from './route/PublicRoute';
import ProfessionalAcceptanceGuard from "./utils/ProfessionalAcceptanceGuard";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Importation des pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ActivityTracker from './utils/ActivityTracker';
import UserManagementPage from './pages/admin/UserManagementPage';
import ClientManagementPage from './pages/admin/ClientManagementPage';
import ProfessionalManagementPage from './pages/admin/ProfessionalManagementPage';
import ProfessionalCandidatePage from './pages/professional/ProfessionalCandidatePage';
import ContractsPage from './pages/admin/ContractsPage';
import ServiceManagementPage from './pages/admin/ServiceManagementPage';
import SettingsPage from './pages/admin/SettingsPage';
import DashboardPage from './pages/admin/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import NotFoundPage from './pages/NotFoundPage';
import ProDashboardPage from "./pages/professional/ProDashboardPage";
import ProContractsPage from "./pages/professional/ProContractsPage";
import ClientDashboardPage from "./pages/client/ClientDashboardPage";
import ClientIdentificationPage from "./pages/client/ClientIdentificationPage";
import ClientContractsPage from "./pages/client/ClientContractsPage";
import ClientEOIListPage from "./pages/client/ClientEOIListPage";
import ValidationRequestPage from "./pages/admin/ValidationRequestPage";
import ContractEmployePage from "./pages/admin/ContractEmployePage";
import MyContractEmployePage from "./pages/professional/MyContractEmployePage";
import ContactPage from "./pages/ContactPage";
import IdentificationPage from "./pages/professional/IdentificationPage";
import ProfessionalPreferencesCompact from "./pages/professional/ProfessionalPreferencesCompact";
import ScrollToTop from './components/ScrollToTop';

//ServicesPages
import BabySitting from "./pages/services/BabySitting";
import AideDomicile from "./pages/services/AideDomicile";
import Menage from "./pages/services/Menage";
import SoutienScolaire from "./pages/services/SoutienScolaire";
import ServicesQuotidien from "./pages/services/ServicesQuotidien";
import ProfessionalsPages from "./pages/ProfessionalsPages";
import ForgotPassword from "./pages/ForgotPassword";
import ForgotUsername from "./pages/ForgotUsername";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import LegalNoticePage from "./pages/LegalNoticePage";


// Création du thème Material-UI
const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
            light: '#42a5f5',
        },
        secondary: {
            main: '#9c27b0',
        },
        background: {
            default: '#f5f5f5',
            paper: '#ffffff',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>

                <ActivityTracker>
                    <Router>
                        <ScrollToTop />
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/baby-sitting" element={<BabySitting />} />
                            <Route path="/aide-domicile" element={<AideDomicile />} />
                            <Route path="/menage" element={<Menage />} />
                            <Route path="/soutien-scolaire" element={<SoutienScolaire />} />
                            {/*<Route path="/services-quotidien" element={<ServicesQuotidien />} />*/}
                            <Route path="/contact" element={<ContactPage />} />

                            {/*<Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                        <Route path="/terms" element={<TermsOfUsePage />} />
                        <Route path="/legal-notice" element={<LegalNoticePage />} />*/}

                            {/* Routes publiques */}
                            <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
                            <Route path="/forgot-username" element={<PublicRoute><ForgotUsername /></PublicRoute>} />
                            <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
                            <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
                            <Route path="/professionals" element={<PublicRoute><ProfessionalsPages /></PublicRoute>} />

                            {/* Routes privées - Admin / Client / Général */}

                            {/* ============================================================================== */}
                            {/* ok
                        {/* ============================================================================== */}
                            <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />

                            <Route path="/services-management" element={<PrivateRoute><ServiceManagementPage /></PrivateRoute>} />
                            <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
                            <Route path="/user" element={<PrivateRoute><UserManagementPage /></PrivateRoute>} />
                            <Route path="/client" element={<PrivateRoute><ClientManagementPage /></PrivateRoute>} />
                            <Route path="/professional" element={<PrivateRoute><ProfessionalManagementPage /></PrivateRoute>} />
                            <Route path="/request" element={<PrivateRoute><ValidationRequestPage /></PrivateRoute>} />
                            <Route path="/contracts" element={<PrivateRoute><ContractsPage /></PrivateRoute>} />



                            <Route path="/professional-candidate" element={<PrivateRoute><ProfessionalCandidatePage /></PrivateRoute>} />
                            <Route path="/client-contracts" element={<PrivateRoute><ClientContractsPage /></PrivateRoute>} />
                            <Route path="/client-list" element={<PrivateRoute><ClientEOIListPage /></PrivateRoute>} />



                            <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />




                            {/* ============================================================================== */}
                            {/* ROUTES PROFESSIONNELLES AVEC GARDE D'ACCEPTATION (ProfessionalAcceptanceGuard) */}
                            {/* ============================================================================== */}
                            <Route path="/client-dashboard" element={<PrivateRoute><ClientDashboardPage /></PrivateRoute>} />
                            <Route path="/identification" element={<PrivateRoute><IdentificationPage /></PrivateRoute>} />
                            <Route path="/client-identification" element={<PrivateRoute><ClientIdentificationPage /></PrivateRoute>} />


                            <Route
                                path="/pro-dashboard"
                                element={
                                    <PrivateRoute>
                                        <ProfessionalAcceptanceGuard>
                                            <ProDashboardPage />
                                        </ProfessionalAcceptanceGuard>
                                    </PrivateRoute>
                                }
                            />

                            {/*<Route
                                path="/availability"
                                element={
                                    <PrivateRoute>
                                        <ProfessionalAcceptanceGuard>
                                            <ProfessionalPreferencesCompact />
                                        </ProfessionalAcceptanceGuard>
                                    </PrivateRoute>
                                }
                            />*/}
                            <Route
                                path="/contrat-employe"
                                element={
                                    <PrivateRoute>
                                        <ProfessionalAcceptanceGuard>
                                            <ContractEmployePage />
                                        </ProfessionalAcceptanceGuard>
                                    </PrivateRoute>
                                }
                            />

                            <Route
                                path="/my-contrat"
                                element={
                                    <PrivateRoute>
                                        <ProfessionalAcceptanceGuard>
                                            <MyContractEmployePage />
                                        </ProfessionalAcceptanceGuard>
                                    </PrivateRoute>
                                }
                            />
                            <Route
                                path="/pro-contracts"
                                element={
                                    <PrivateRoute>
                                        <ProfessionalAcceptanceGuard>
                                            <ProContractsPage />
                                        </ProfessionalAcceptanceGuard>
                                    </PrivateRoute>
                                }
                            />


                            {/* Page 404 */}
                            <Route path="/404" element={<NotFoundPage />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Routes>

                        <ToastContainer
                            position="top-right"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            theme="colored"
                        />
                    </Router>
                </ActivityTracker>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;